const serverPath = process.env.VUE_APP_RESOURCE_PATH;

export default {
  localizeFiles(obj) {
    if (!obj) {
      return null;
    }

    const parsedObj = JSON.parse(obj);
    const languages = Object.keys(parsedObj);
    const items = languages.map((l) => ({
      language: l,
      src: serverPath + parsedObj[l],
    }));

    return items.length > 0 ? items : null;
  },
};
